export const Props = () => ({
  //Объект гифки
  data: {
    type: Object,
  },
});